
import Vue from 'vue'
import { FindByIdMyArqanaHorseRegistrationDto } from '@/api/auth/myHorseRegistration'
import { documentsRule } from '@/views/registration/documents/rules'

export default Vue.extend({
  name: 'RegistrationStatus',
  props: {
    registration: Object as () => FindByIdMyArqanaHorseRegistrationDto,
    documentsOpen: Boolean,
    pedigreesOpen: Boolean,
    large: { type: Boolean, default: false },
  },
  computed: {
    allMandatoryDocumentsOK(): boolean {
      const rules = documentsRule[this.registration.type]
      if (!this.registration.documents) {
        return false
      }
      if (rules) {
        const entries = Object.values(rules)
        return Object.keys(rules)
          .map((key, i) => ({ type: key, rule: entries[i] }))
          .filter(e => e.rule === 'COMPULSORY' || e.rule === 'COMPULSORY_IF_COVERED')
          .map(e => e.type)
          .every(e => this.registration.documents.find(x => x.type === e)?.status === 'ACCEPTED')
      }
      return true
    },
  },
})
